import { render, staticRenderFns } from "./CheckboxCopySlideNote.vue?vue&type=template&id=c098a5f2&scoped=true&"
import script from "./CheckboxCopySlideNote.vue?vue&type=script&lang=js&"
export * from "./CheckboxCopySlideNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c098a5f2",
  null
  
)

export default component.exports